import { Toast } from 'vant';
import Validator from '@utils/_validator';
import Common from '@constants/_common';
import APIS from '@apis';
import eventBus from '@utils/_eventBus';
export default {
  computed: {
    buttonDisbled () {
     if (this.isNewsForm) {
      if (this.form.productCode.length && this.form.realName && this.form.mobile && this.form.companyName && this.form.areaCode.length && this.form.checked && this.form.privacy) {
        return false;
      } else {
        return true;
      }
     } else if (this.ServiceForm) {
      if (this.form.productCode.length && this.form.realName && this.form.mobile && this.form.companyName && this.form.companyAddress.length && this.form.machineNum.length && this.form.mbModel.length && this.form.areaCode.length) {
        return false;
      } else {
        return true;
      }
     } else {
        if (this.form.productCode.length && this.form.realName && this.form.mobile && this.form.companyName && this.form.areaCode.length) {
          return false;
        } else {
          return true
        }
     }
    },
    isTable () {
      if (this.form.productCode.length && this.form.realName && this.form.mobile && this.form.companyName && this.form.areaCode.length && this.form.rooms.length && this.form.mbNums.length && this.form.checked && this.form.privacy && this.form.mbModel && this.form.machineNum) {
        return true;
      } else {
        return false
      }
    }
  },
  created() {
    this.form.fromRes = this.$route.query.form ? this.getFromText(this.$route.query.form) : null,
    this.isNewsForm = this.$store.state.isNewsForm;
    if (this.$route.name === 'ServiceMonth') {
      this.ServiceForm = true;
    } else {
      this.ServiceForm = false;
    }
  },
  data () {
    return {
      submitLoading: false,
      phoneFormatError: false,
      isNewsForm: false,
      isServiceForm: false,
      form: {
        productCode: [1],
        realName: '',
        mobile: '',
        companyName: '',
        areaCode: [],
        companyAddress: '',
        rooms: '',
        mbNums: '',
        mbModel: '',
        machineNum: '',
        checked: false,
        privacy: false,
        email: '',
        fromRes: '',
        puzzle: ''
      }
    }
  },
  methods: {
    submitForm () {
      if (Validator.isPhoneNumber(this.form.mobile)) {
        this.submitLoading = true;
        this.form.product = this.form.productCode.map(item => {
          return Common.PRODUCT_LIST[item];
        });
        this.form.area = this.form.areaCode.map(item => {
          return item.name;
        }).join(' ');
        const params = {
          content: JSON.stringify(this.form),
          from: window.location.href
        };
        APIS.submitForm(params).then(res => {
          eventBus.$emit('submitSuccessCallBack'); // 百度、头条等广告商需要的转化率（提交成功之后算作一个转化率）
          this.$router.push({name: 'submitSuccess', params: res, query: {from: this.$route.path}});
          this.submitLoading = false;
        }).catch(err => {
          this.submitLoading = false;
          switch (+err.data.code) {
            case 4001003: 
              Toast.fail('请勿重复提交');
              break;
            default:
              Toast.fail('服务器异常');
          }
        });
      } else {
        this.phoneFormatError = true;
      }
    },
    hideError () {
      this.phoneFormatError = false;
    },
    handleSelectProduct (result) {
      this.form.productCode = result;
    },
    handleSelectArea (result) {
      this.form.areaCode = result;
    },
    getFromText(form) {
      if (form) {
          form = decodeURIComponent(form).toLocaleLowerCase()
          if (['360'].includes(form)) {
              form= '360SEM'
          } else if (['ad', 'admh', 'adhypb'].includes(form)) {
              form= '百度SEM'
          } else if (['bdad'].includes(form)) {
              form= '百度品专'
          }
      }
      return form || 'MAXHUB官网'
    }
  }
}